import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import styles from "./TemplateComparison.module.css";

const STATUS_MAP = { 0: "pending", 1: "approved", 2: "rejected" };

const TemplateComparison = ({ templates, onClose }) => {
  if (!templates || templates.length < 2) return null;

  const chartData = templates.map((t) => ({
    name: t.temp_name,
    sent: t.sent || 0,
    read: Math.round((t.sent || 0) * 0.9),
  }));

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div>
          <div className={styles.title}>Performance Comparison</div>
          <div className={styles.subtitle}>
            Comparing metrics for {templates.length} selected templates
          </div>
        </div>

        <button className={styles.closeBtn} onClick={onClose}>
          ×
        </button>
      </div>

      <div className={styles.content}>
        {/* LEFT: METRICS TABLE */}
        <div className={styles.left}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th className={styles.metricCol}>Metric</th>
                {templates.map((t, i) => (
                  <th key={t.id ?? i} className={styles.templateCol}>
                    {t.temp_name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>

              <tr>
                <td>Channel</td>
                {templates.map((t, i) => (
                  <td key={t.id ?? i}>
                    <span className={`${styles.channelBadge} ${styles.whatsapp}`}>
                      WHATSAPP
                    </span>
                  </td>
                ))}
              </tr>

              <tr>
                <td>Status</td>
                {templates.map((t, i) => {
                  const status = STATUS_MAP[t.temp_status] || "pending";
                  return (
                    <td key={t.id ?? i}>
                      <span className={`${styles.statusPill} ${styles[status]}`}>
                        {status.charAt(0).toUpperCase() + status.slice(1)}
                      </span>
                    </td>
                  );
                })}
              </tr>
              <tr>
                <td>Total Sent</td>
                {templates.map((t, i) => (
                  <td key={t.id ?? i}>{(t.sent || 0).toLocaleString()}</td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>

        {/* RIGHT: CHART */}
        <div className={styles.right}>
          <ResponsiveContainer width="100%" height={260}>
            <BarChart data={chartData}>
              <CartesianGrid stroke="#EEF2F7" vertical={false} />
              <XAxis
                dataKey="name"
                tick={{ fontSize: 11, fill: "#64748B" }}
                interval={0}
              />
              <YAxis tick={{ fontSize: 11, fill: "#64748B" }} />
              <Bar
                dataKey="sent"
                fill="#6366F1"
                radius={[4, 4, 0, 0]}
              />
              <Bar
                dataKey="read"
                fill="#34D399"
                radius={[4, 4, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default TemplateComparison;
